import { render, staticRenderFns } from "./dialog_tarjeta.vue?vue&type=template&id=1dd4462a"
import script from "./dialog_tarjeta.js?vue&type=script&lang=js&external"
export * from "./dialog_tarjeta.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports